export default __webpack_public_path__ + "static/bg-ford-6a539b499bf7481d547838cae26f2dbb.webp";